import { useLocation, useNavigate, useParams } from "react-router-dom"
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore';
import { useFirestore, useFirestoreDocData, useStorage } from 'reactfire';
import { uploadString, ref } from "firebase/storage";
import { useEffect, useState } from "react";
import './CMSGroveForm.scss';
import useParksById from "../../hooks/useParksById";
import { Link } from 'react-router-dom';
import { useLocalStorage } from 'react-use';
import CMSMap from "./CMSMap";
import Select from 'react-select'
import ImageUploader from "./ImageUploader";
import slugger from 'slug'
import PulseLoader from "react-spinners/PulseLoader";
import classNames from "classnames";

function CMSGroveFormEdit(props) {
  const { id } = props
  const firestore = useFirestore();
  const ref = doc(firestore, 'groves', id);
  const { data: grove } = useFirestoreDocData(ref);

  return <CMSGroveFormForm id={id} grove={grove} groveRef={ref} {...props} />
}
export default function CMSGroveForm(props) {
  const { id } = useParams()
  if (id) {
    return <CMSGroveFormEdit id={id} {...props} />
  }
  return <CMSGroveFormForm {...props} />

}
function CMSGroveFormForm(props) {
  const { grove, groveRef, isAdmin } = props
  const [,setHasUnpublishedChanges] = useLocalStorage('unpublishedChanges', false)

  const [name, setName] = useState('');
  const [yearDedicated, setYearDedicated] = useState('');
  const [dedicatedBy, setDedicatedBy] = useState('');
  const [park, setPark] = useState('');
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [images, setImages] = useState([])
  const [slug, setSlug] = useState('')
  const [locationEstimation, setLocationEstimation] = useState(false)
  const [ancestralLand, setAncestralLand] = useState('')
  const [backgroundStory, setBackgroundStory] = useState('')
  const parks = useParksById()
  const verb = grove ? 'Edit' : 'Add'
  const location = useLocation()
  const firestore = useFirestore()
  const [status, setStatus] = useState(null)
  const grovesCollection = collection(firestore, 'groves');
  const navigation = useNavigate()
  const [rerenderMap, setRerenderMap] = useState(0)
  const storage = useStorage()
  useEffect(() => {
    if (grove) {
      setName(grove.name);
      setYearDedicated(grove.yearDedicated || '');
      setDedicatedBy(grove.dedicatedBy || '');
      setPark(grove.park || '');
      setLat(grove.lat || '');
      setLng(grove.lng || '');
      setImages(grove.images || []);
      setSlug(grove.slug || '')
      setLocationEstimation(grove.locationEstimation || false)
      setAncestralLand(grove.ancestralLand || '')
      setBackgroundStory(grove.backgroundStory || '')
    }

  }, [grove])

  const update = (setter) => (e) => {
    setter(e.target.value)
  }
  const cancelLink = location.pathname.substring(0, location.pathname.indexOf(verb.toLowerCase() ) - 1)
  const submit = async (e) => {
    e.preventDefault()

    const newImages = images.filter(image => image.new)
    if (newImages.length) {
      setStatus(`uploading ${newImages.length} image${newImages.length > 1 ? 's' : ''}`)

      await Promise.all(newImages.map(image => {
        const data = image.path
        const imageRef = ref(storage, 'grove-images/' + image.name)
        return uploadString(imageRef, data, 'data_url')
      }))
    }
    const imageDataToSave = images.map(image => {
      const imageData = { ...image }
      delete imageData.new
      delete imageData.editing
      delete imageData.path
      return imageData
    })

    const groveObject = {
      name,
      yearDedicated,
      dedicatedBy,
      park,
      lat,
      lng,
      images: imageDataToSave,
      slug,
      locationEstimation,
      ancestralLand,
      backgroundStory,

    }
    if (grove) {
      setStatus('Updating Grove')
      await updateDoc(groveRef, groveObject)
      setHasUnpublishedChanges(true)
      navigation(`${cancelLink}?status=edited`)
    } else {
      setStatus('Adding Grove')
      await addDoc(grovesCollection, groveObject)
      setHasUnpublishedChanges(true)
      navigation(`${cancelLink}?status=added`)
    }

  }
  const mapWidth = window.innerWidth * 0.4
  const mapHeight = mapWidth * 9 / 16
  const typeLatLong = (setter) => e => {
    setter(+e.target.value)
    setRerenderMap(rerenderMap + 1)
  }
  const setLatLng = (latLng) => {
    setLat(+latLng.lat)
    setLng(+latLng.lng)
  }
  const parkOptions = Object.keys(parks).map(parkId => {
    return {
      value: parkId,
      label: parks[parkId].name
    }
  })
  const selectedPark = parkOptions.find(option => option.value === park)
  const updateName = (e) => {
    const name = e.target.value
    setSlug(slugger(name))
    setName(name)
  }
  return (
    <div className='CMSGroveForm'>
      <Link className='backToLink' to='/cms/groves'>Back to groves list</Link>
      <h2>{verb} Grove</h2>
      {
        status ?
        <div className={`status ${slugger(status)}`}>{status} <PulseLoader size={'0.5em'} color="#14816E" /></div>
        : null
      }
      <form>
        <div className='formLeft'>
          <div className='flex'>

            <label>
              <label>
                <span>Grove Name</span>
                <input tabIndex={1} className='textInput' placeholder='Grove Name' type='text' value={name} onChange={updateName} />
              </label>
              <label>
                <span>Donor Name</span>
                <input tabIndex={3} className='textInput' placeholder="Donor Name" type='text' value={dedicatedBy} onChange={update(setDedicatedBy)} />
              </label>
              <label>
                <span>Traditional Indigenous Land</span>
                <input tabIndex={3} className='textInput' placeholder="Muwekma Ohlone" type='text' value={ancestralLand} onChange={update(setAncestralLand)} />
              </label>

              <label>
                <span>Park:</span>
                <Select
                  classNamePrefix='react-select'
                  placeholder='Select a park...'
                  value={selectedPark}
                  onChange={e => setPark(e.value)}
                  options={parkOptions}
                  tabIndex={4}
                />
              </label>
              {isAdmin ? (
                <label>
                  <span>Slug:</span>
                  <input disabled readOnly value={slug} />
                </label>
              ) : null }
            </label>
            <label style={{ marginLeft: '2em' }}>
              <span>Year Dedicated</span>
              <input tabIndex={2} className='yearInput' placeholder="YYYY"  type='number' value={yearDedicated} onChange={update(setYearDedicated)} />
            </label>
          </div>
          <div className='flex latLng'>
            <label>
              <span>Latitude</span>
              <input tabIndex={5} placeholder='0.00000' type='number' value={lat} onChange={typeLatLong(setLat)} />
            </label>
            <label>
              <span>Longitude</span>
              <input tabIndex={6} placeholder='0.00000' type='number' value={lng} onChange={typeLatLong(setLng)} />
            </label>
            <div className='instructions'>
              Double click the map to drop a pin, or click and drag the existing pin
            </div>
          </div>
          <label>
            <span data-tip='Check this box to show a notice indicating the lat/long coordinates are an estimated location'>Show Location Estimation Notice</span>
            <input type="checkbox" checked={locationEstimation} onChange={e => setLocationEstimation(e.target.checked)} />
          </label>
          <div>
            <CMSMap
              lat={lat}
              lng={lng}
              width={mapWidth}
              height={mapHeight}
              setLatLng={setLatLng}
              rerenderMap={rerenderMap}
              park={park}
            />
          </div>
        </div>
        <div className='formRight'>
          <ImageUploader
            images={images}
            setImages={setImages}
          />

          <label className='backgroundStory'>
              <span>Background Story</span>
              <textarea
                className={ classNames({ hasContent: backgroundStory.length }) }
                tabIndex={7}
                placeholder='Click to expand and add background text.'
                value={backgroundStory} onChange={update(setBackgroundStory)} />
            </label>
        </div>
        <div className='submissionButtons'>
          <Link to={cancelLink} className='button cancel'><span className='cancelX'>&times;</span> Cancel</Link>
          <button onClick={submit} className='button'>Save Grove</button>
        </div>
      </form>
    </div>
  )
}
